export function checkbox(_ctx) {
    return {
        styles: {
            main:   { border_width: 0, text_color: '#ffffff', text_font: 32 },
            bullet: {
                bg_color: '#000000', border_color: '#ffffff', border_width: 2,
                states: {
                    checked: { bg_color: '#666666' },
                    pressed: { bg_color: '#555555' },
                },
            },
        },
    };
}
